import React from "react";

export default function CheckCircle() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="checkCircleMask0"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="14"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.33325 8C1.33325 4.32 4.31992 1.33333 7.99992 1.33333C11.6799 1.33333 14.6666 4.32 14.6666 8C14.6666 11.68 11.6799 14.6667 7.99992 14.6667C4.31992 14.6667 1.33325 11.68 1.33325 8ZM3.33325 8L6.66658 11.3333L12.6666 5.33333L11.7266 4.38667L6.66658 9.44667L4.27325 7.06L3.33325 8Z"
          fill="white"
        />
      </mask>
      <g mask="url(#checkCircleMask0)">
        <rect width="16" height="16" fill="#009A76" />
      </g>
    </svg>
  );
}
